;(function(){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _sweetalert = require("sweetalert2");

var _sweetalert2 = _interopRequireDefault(_sweetalert);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: "Complete",
  props: {
    status_api_url: {
      type: String,
      required: true,
      default: ""
    },
    invoice_no: {
      type: String,
      required: true,
      default: ""
    },
    gateway_id: {
      type: String,
      required: true,
      default: ""
    },
    callback_url: {
      type: String,
      required: true,
      default: ""
    },
    btn_class: {
      type: String,
      required: false,
      default: "btn btn-primary"
    },
    loading: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  data: function data() {
    return {
      loading: false,
      poll_external: false,
      redirecting_you: false,
      timer: null
    };
  },

  mounted: function mounted() {
    this.poll_external = this.$attrs["poll_external"] || false;
    this.complete_payment();
  },

  methods: {
    destroyTimer: function destroyTimer() {
      this.loading = false;
      this.$emit("stop-loader");
      if (this.timer) {
        clearInterval(this.timer);
      }
    },

    complete_payment: function complete_payment() {
      var _this = this;

      this.loading = true;
      var retryCount = 0;

      var intervalId = setInterval(function () {
        _this.check_status();

        retryCount++;

        if (retryCount >= 3) {
          clearInterval(intervalId);
          _this.loading = false;
          _this.$emit("stop-loader");
        }
      }, 4000);
    },
    check_status: function check_status() {
      var _this2 = this;

      var payload = {
        invoiceNumber: this.invoice_no,
        gateway_id: this.gateway_id,
        poll_external: false
      };
      Vue.axios.post(this.status_api_url, payload).then(function (response) {
        if (response.data === "OK") {
          clearInterval(_this2.timer);
          _this2.translate(response.data);
        } else if (response.data === "PENDING") {
          clearInterval(_this2.timer);
          _this2.loading = false;
          _this2.$emit("stop-loader");
          _this2.redirecting_you = false;
          _sweetalert2.default.fire({
            icon: "error",
            title: "Payment Info",
            text: "Payment is still pending."
          });
        } else if (response.data === "CANCELLED") {
          clearInterval(_this2.timer);
          _this2.loading = false;
          _this2.$emit("stop-loader");
          _this2.redirecting_you = false;
          _sweetalert2.default.fire({
            icon: "error",
            title: "Payment Info",
            text: "Payment was cancelled."
          });
        }
      }).catch(function (error) {}).then(function () {});
    },

    translate: function translate(response) {
      this.loading = false;
      this.$emit("stop-loader");
      this.redirecting_you = true;
      if (this.callback_url != null && this.callback_url.length > 0) {
        window.top.location.href = this.callback_url;
      } else {
        this.redirecting_you = false;
        _sweetalert2.default.fire({
          icon: "success",
          title: "Payment Info",
          text: "Payment was completed."
        });
      }
    }
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loading)?_c('div',[_vm._m(0)]):_vm._e(),_vm._v(" "),(_vm.redirecting_you)?_c('div',[_vm._m(1)]):_vm._e()])}
__vue__options__.staticRenderFns = [function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-col justify-center items-center h-full"},[_c('h2',{staticClass:"text-3xl text-gray-500 font-semibold leading-[38.68px] text-center mb-9 sm:mb-16"},[_vm._v("\n        Confirming payment\n      ")]),_vm._v(" "),_c('div',{staticClass:"flex justify-center items-center w-full py-4 min-h-80"},[_c('img',{staticClass:"animate-spin w-24",attrs:{"src":"/iframev2/assets/img/png/loader.png","alt":"Loader img"}})])])},function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-col justify-center items-center h-full"},[_c('h2',{staticClass:"text-3xl text-gray-500 font-semibold leading-[38.68px] text-center mb-9 sm:mb-16"},[_vm._v("\n        Redirecting you ...\n      ")]),_vm._v(" "),_c('div',{staticClass:"flex justify-center items-center w-full py-4 min-h-80"},[_c('img',{staticClass:"animate-spin w-24",attrs:{"src":"/iframev2/assets/img/png/loader.png","alt":"Loader img"}})])])}]
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-63237c16", __vue__options__)
  } else {
    hotAPI.reload("data-v-63237c16", __vue__options__)
  }
})()}